import { useState, useCallback, useRef } from "react"

export function useReport(fetchFn) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const abortRef = useRef(null)

  const fetch = useCallback(async (filters = {}) => {
    if (abortRef.current) abortRef.current.abort()
    abortRef.current = new AbortController()

    setLoading(true)
    setError(null)
    try {
      const result = await fetchFn(filters)
      setData(result)
    } catch (err) {
      if (err.name !== "AbortError") setError(err)
    } finally {
      setLoading(false)
    }
  }, [fetchFn])

  const reload = useCallback((filters) => fetch(filters), [fetch])

  return { data, loading, error, fetch, reload }
}
